<template>
    <div class="news-container">
        <info-header @change-cate="onCateChange" @change-sub-cate="onSubCateChange"></info-header>
        <div class="news-page-body">
            <div class="right-content">
                <div class="right-top" v-if="!selected_sub_category_id">
                    <div class="banner">
                        <div class="swiper-container">
                            <swiper :options="swiperOptions" ref="mySwiper" v-if="banner_list.length">
                                <!-- Slides -->
                                <swiper-slide v-for="(item,index) in banner_list" :key="index" @click="onSwiperClick(item)">
                                    <img :src="item.image" class="swiper-img" />
                                </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="hot-news">
                        <div class="hot-news-title-box">
                            <div class="hot-news-title"><img src="../../assets/images/icon-hot-news.png" />Hot News</div>
                        </div>
                        <div class="hot-news-list">
                            <div class="hot-news-item" v-for="(v,k) in hot_list" :key="`hot-`+k" @click="onDetailClick(v)">
                                <div class="item-box">
                                    <div class="item-border">
                                        <img :src="v.cover|default_img" class="cover-img" />
                                        <div class="title-time-box">
                                            <div class="title">{{v.title}}</div>
                                            <div class="content">{{ v.content | plainText }}</div>
                                            <div class="time">{{v.create_time | enDate}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-title">LATEST IN NEWS</div>
                <div class="right-list-content">
                    <div class="list-item" v-for="(v,k) in infiniteList" :key="`list`+k" @click="onDetailClick(v)">
                        <img :src="v.cover|default_img" class="cover-img" />
                        <div class="list-item-title">{{v.title}}</div>
                        <div class="list-item-content">{{ v.content | plainText }}</div>
                        <div class="list-item-date">{{v.create_time | enDate}}</div>
                    </div>
                </div>
                <div class="more-btn">
                    <!-- <Button @click="getInfiniteList(false)" shape="circle" class="btn">MORE+</Button> -->
                    <Page :total="total_count" :current.sync="pageIndex" show-elevator @on-change="onPageChange" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
import C from '@/utils/constant'
import { GetBannerList } from '@/api/index';
import { InfoCategory, InfoList, InfoHotList } from '@/api/social'
import infinite from '@/mixins/infinite'
import InfoHeader from '@/components/InfoHeader/InfoHeader'
export default {
    name: 'InfoIndex',
    components: {
        swiper,
        swiperSlide,
        InfoHeader
    },
    mixins:[infinite],
    // filters:{
    //     plainText(value) {
    //         if (!value) return '';
    //         const div = document.createElement('div');
    //         div.innerHTML = value;
    //         return div.textContent || div.innerText || '';
    //     }
    // },
    data() {
        return {
            swiperOptions: {
                // 核心配置
                slidesPerView: 1,           // 每页显示 1 张幻灯片
                centeredSlides: true,       // 当前幻灯片居中显示
                spaceBetween: 10,           // 幻灯片间距
                loop: true,                 // 启用循环模式
                loopedSlides: 0,
                grabCursor: true,           // 拖动时显示抓手光标
                autoplay: {
                    delay: 3000, // 3秒切换
                    disableOnInteraction: false // 手动滑动后继续自动播放
                },

                pagination: {
                    el: '.swiper-pagination', // 指定分页器容器选择器
                    type: 'bullets',          // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
                    clickable: true,          // 允许点击分页器切换幻灯片
                    bulletActiveClass: 'my-swiper-pagination-active', // 自定义激活状态类名
                },
            },
            selected_category_id: 0,
            selected_sub_category_id: 0,
            category_list: [],
            banner_list:[],
            hot_list: [],
            pageIndex:1,
            total_count:0
        }
    },
    computed:{
        sub_category_list() {
            const arr = [];
            arr.push({id:0,title:'ALL'})
            let cate = this.category_list.find(v=>v.id===this.selected_category_id)
            if (!cate || !cate.children || !cate.children.length) {
                return arr;
            }
            arr.push(...cate.children);
            return arr ? arr : []
        },
        sel_category(){
            return this.$_.cloneDeep(this.category_list.find(item => item.id === this.selected_category_id)) || {};
        }
    },
    watch:{
        selected_category_id(newVal, oldVal){
            this.selected_sub_category_id = 0;
            this.getHotList()
            this.getInfiniteList(true);
        },
        selected_sub_category_id(newVal, oldVal) {
            if(newVal > 0) {
                this.getInfiniteList(true);
            }
        },
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'light');
			});
		},	
    mounted() {
        this.onGetBannerList();
        this.getHotList()
    },
    methods: {
        onSubCateChange(e){
            console.log('sub-cate-change',e);
            const {selected_category_id,selected_sub_category_id} = e;
            this.selected_category_id = selected_category_id;
            this.selected_sub_category_id = selected_sub_category_id;
            this.getInfiniteList(true);
        },
        onCateChange(e){
            console.log('cate-change',e);
            this.getHotList()
            this.getInfiniteList(true);
        },
        onPageChange(page){
            this.pageIndex = page;
            this.getInfiniteData(page,20);
        },
        
        async getHotList() {
            InfoHotList({page: 1, limit: 10, category_id: this.selected_sub_category_id || this.selected_category_id}).then(response => {
                this.hot_list = response.data
            })
        },
        async getInfiniteData(pageIndex,pageSize){
            const {data} = await InfoList({page: pageIndex, limit: pageSize, category_id: this.selected_sub_category_id || this.selected_category_id})
            this.total_count = data.count || 0;
            return {data:data.list};
        },
        async onGetBannerList(){
            const {data} = await GetBannerList({position: C.BANNER_POSITION_INFO});
            this.banner_list = [];
            this.swiperOptions.loopedSlides = data.length;
            this.banner_list = data;
        },
        onDetailClick(item){
            window.open(`${location.protocol}//${location.host}/info/detail?uuid=${item.uuid}`)
            // this.$router.push({name:'InfoDetail',query:{uuid:item.uuid}});
        },
        onSwiperClick(item){
            console.log('轮播点击',item);
        },


    }
}
</script>
<style lang="scss" scoped>
@import './news.scss';
</style>
